module.exports = __webpack_public_path__ + "z.no2.c5b7f36f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/z.no2.jpg
// module id = cSn4
// module chunks = 0